
import { computed, defineComponent, PropType, ref } from 'vue'
import { ActionBtn } from '../ActionBtn'
import { VueQrious } from '../VueQrious'
import { TGroup } from '@/types'

export default defineComponent({
  name: 'Result',
  components: { ActionBtn, VueQrious },
  props: {
    resultList: {
      type: Array as PropType<TGroup[]>,
      default: () => []
    }
  },
  setup (props) {
    const otherRecomment = computed(() => {
      return props.resultList.length > 1 ? props.resultList.slice(1) : []
    })
    return {
      otherRecomment,
      qrRef: ref({} as typeof VueQrious)
    }
  },
  methods: {
    qrPreview () {
      this.$preview({
        images: [this.qrRef.dataUrl]
      })
    }
  }
})
